/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { CalendarDate } from '@internationalized/date';
import { utcStringToCalendarDate } from 'sarsaparilla';

export interface ItemWithAvailableDates {
    available_dates?: Array<{ start_date?: string; end_date?: string }>;
}

export interface AvailableDateRange {
    start: CalendarDate;
    end: CalendarDate;
}

/**
 * Reads an item's first available date range. Flexible date searches return
 * `available_dates` as UTC date-time strings whose time zone is meaningless.
 * @param item a search result or recommendation
 * @returns the first range as calendar dates, or `null` if it is missing or malformed
 */
export function getAvailableDateRange(
    item: ItemWithAvailableDates
): AvailableDateRange | null {
    try {
        const start = utcStringToCalendarDate(item.available_dates?.[0]?.start_date);
        const end = utcStringToCalendarDate(item.available_dates?.[0]?.end_date);

        if (!start || !end) return null;

        return { start, end };
    } catch {
        // utcStringToCalendarDate throws on strings that aren't ISO date-times
        return null;
    }
}
